/**
 * Phase 20 / Task 20.7 — the template catalog (`GET /v1/import-templates`).
 *
 * One query for the two screens that need it: the Templates page lists it, and
 * step 1's per-sheet "Import as" selector offers it. The catalog changes only
 * with a deploy, so it is cached for the session's working time.
 */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useApiOpts } from '@lodex-pro/web-shared';

import { importRequest } from './api';

export interface TemplateSummary {
  readonly key: string;
  readonly code: string;
  readonly sheetName: string;
  readonly purpose: string;
  readonly order: number;
}

interface TemplatesResponse {
  readonly templates: readonly TemplateSummary[];
}

export function useTemplateCatalog(): UseQueryResult<readonly TemplateSummary[]> {
  const apiOpts = useApiOpts();
  return useQuery({
    queryKey: ['import-templates'],
    queryFn: async () =>
      [
        ...(await importRequest<TemplatesResponse>(apiOpts, 'GET', '/v1/import-templates'))
          .templates,
      ].sort((a, b) => a.order - b.order),
    staleTime: 5 * 60_000,
  });
}
